<template>
  <div class="app">
    <h1>OCR Free Tool Pc Segura</h1>
    <div class="image">
      <div class ="resultado">
        <div class="container">
          <div class="row">
            <img
              id="text-img"
              :src="image"
              v-if="showImage"
              ref="image"
              :class="[{ loading: showProgress }]"
            />
          </div>
        </div>
        <div class="container">
          <div class="row">
            <progress :value="progress" max="100" v-if="showProgress">
              {{ progress }} %
            </progress>
            <!-- <div class="log" v-if="showProgress">
          <div
            v-for="{ phase, status, time } in log"
            :key="`item-${phase}-${status}`"
          >
            <div class="item">[{{ time }}]: {{ phase }}..... {{ status }}</div>
          </div>
        </div>-->
          </div>
        </div>

        <div class="container result" v-if="text">
          <div class="row">
            <div v-text="text" class="text"></div>
            <button
            @click="copy"
          >
            Copiar! 
          </button>
          </div>
        </div>
      </div>
      <div class="container button-group">
        <div class="row">
          <button
            :class="['primary', { disabled: !readyUpload }]"
            @click="upload"
          >
            Seleccionar 
          </button>
        </div>

        <div class="row">
          <button
            v-on:click="recognize"
            :class="['primary', readyOCR !== 0 ? '' : 'disabled']"
          >
            Leer Imagen
          </button>
        </div>
      </div>
      <input
        class="input"
        type="file"
        accept="image/*"
        @change="setFile"
        ref="file"
      />
    </div>
  </div>
</template>

<script>
import { createWorker, PSM, OEM, languages } from "tesseract.js";

export default {
  name: "vue-ocr",
  data() {
    return {
      image: null,
      readyOCR: false,
      readyUpload: true,
      showImage: false,
      showProgress: false,
      progress: 0,
      work: null,
      text: "",
      log: [],
      languages,
    };
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.text);

    },



    getTime() {
      const options = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
      };
      return new Intl.DateTimeFormat("es-Es", options).format(new Date());
    },
    upload() {
      this.$refs.file.click();
    },
    setFile(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.image = reader.result;
        this.showImage = true;
        this.readyOCR = true;
      };
      reader.readAsDataURL(file);
    },
    isBussy(status) {
      this.showProgress = status;
      this.readyOCR = !status;
      this.readyUpload = !status;
    },
    async recognize() {
      this.isBussy(true);
      await this.work.load();
      /*
      await this.work.loadLanguage(this.selectedLang);
      await this.work.initialize(this.selectedLang, OEM.LSTM_ONLY);*/
      await this.work.loadLanguage("spa");
      await this.work.initialize("spa", OEM.LSTM_ONLY);

      await this.work.setParameters({
        tessedit_pageseg_mode: PSM.SINGLE_BLOCK,
      });
      const {
        data: { text },
      } = await this.work.recognize(this.$refs.image);
      this.text = text;
      this.isBussy(false);
      this.log = [];
    },
    saveLog({ status, progress }) {
      this.log.push({
        time: this.getTime(),
        phase: status,
        status: progress === 0 ? "Start" : "End",
      });
    },
    worker() {
      this.work = createWorker({
        logger: (data) => {
          if (data.status === "recognizing text") {
            this.progress = data.progress * 100;
            data.progress === 1 || (data.progress === 0 && this.saveLog(data));
          } else {
            this.saveLog(data);
          }
        },
      });
    },
  },
  mounted() {
    this.worker();
  },
};
</script>

<style>
.app {
  font-family:sans-serif;
  margin: auto;
  font-size: 15px;
  font-family: Verdana;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 1024px;
  justify-content: center;
}

.button-group {
  display: flex;
  flex-direction: row;
}
.button-group .row {
  margin: 0px 5px 0px 5px;
}
.button-group button {
  width: 150px;
  border-radius: 5px;
  background: #0069ff;
  font-size: 16px ;
  font-family:sans-serif;
  border: none;
  cursor: pointer;
  outline: inherit;
  padding:5px;
  color: white;

}

.result button{width: 100px;
  background: #0069ff;
  border-radius: 5px;
  font-size: 16px ;
  font-family:sans-serif;
  border: none;
  cursor: pointer;
  outline: inherit;
  padding:5px;
  color: white;
  margin-left: 5px;

}
.result .row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.resultado{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.container{
  margin-bottom: 20px;
}

.text{
  font-size: 17px ;
}

.input {
  display: none;
}



</style>
